import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CarrierReportService } from '../../services/carrier-report.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-display-carrier-report',
    templateUrl: './display-carrier-report.component.html',
    styleUrls: ['./display-carrier-report.component.css', '../../app.component.css']
})

export class DisplayCarrierReportComponent implements OnInit, OnDestroy {

    report: any = [];

    id: string;

    employeesReport: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Empleado', name: 'employeeName', sort: 'asc' },
        { title: 'Turno', name: 'workShiftName' }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['striped']
    };

    gcrSubs: Subscription;
    gerSubs: Subscription;
    paramSub: Subscription;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private carrierReportService: CarrierReportService) {
        this.paramSub = this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            if(this.gcrSubs) this.gcrSubs.unsubscribe();
            this.gcrSubs = this.carrierReportService.getCarrierReport(this.id).subscribe(reportObj => {
                this.gcrSubs.unsubscribe();

                this.report = reportObj[0];

                this.report.projectName = this.report.productionOrderObj.productionOrderName;
                this.report.carrierName = this.report.employeeObj.employeeName;
                this.report.reportDate = Utils.convertDatefromStringtoISOString(this.report.reportDate);
            });

            this.loadEmployeesReport();
        });
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        this.paramSub.unsubscribe();
    }

    loadEmployeesReport() {
        this.gerSubs = this.carrierReportService.getEmployeesReport(this.id).subscribe(tempEmployeesReport => {
            this.gerSubs.unsubscribe();

            this.employeesReport = [];

            for (const idx in tempEmployeesReport) {
                this.employeesReport.push(tempEmployeesReport[idx]);
            }

            this.data = this.employeesReport;
            this.length = this.data.length;
            this.onChangeTable(this.config);
        });
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
